import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../fetch'
import { baseURL, commonHeaders } from '../../../../Containers/Confiq/index.js'

import {
  GET_COUPON_SERVICE,
  GET_COUPON_SERVICE_SUCCESS,
  GET_COUPON_SERVICE_ERROR,
} from './../../actionType.js'

function* getCouponService({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/?where=${payload.param}`,
      method: 'GET',
      // headers: { ...commonHeaders },
    })

    if (response?.error === undefined) {
      yield put({ type: GET_COUPON_SERVICE_SUCCESS, payload: response })
    } else {
      yield put({ type: GET_COUPON_SERVICE_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_COUPON_SERVICE_ERROR, payload: error })
  }
}

export function* watchGetCouponService() {
  yield takeEvery(GET_COUPON_SERVICE, getCouponService)
}

function* getCouponServiceSaga() {
  yield all([fork(watchGetCouponService)])
}

export default getCouponServiceSaga
